import React, { useEffect } from "react";
import { Box, Grid, GridItem } from "@chakra-ui/react";
import useArticleStore from "../stores/useArticleStore";
import useFeedStore from "../stores/useFeedStore";

// Components
import AIIndustryNews from "../components/articles/AIIndustryNews"; // AI Industry News component
import Web3News from "../components/articles/Web3News"; // Web3 News component
import EntrepreneurNews from "../components/articles/EntrepreneurNews"; // Entrepreneur News component
import InvestorNews from "../components/articles/InvestorNews"; // Investor News component
import SoloCompanyNews from "../components/articles/SoloCompanyNews"; // Solo Company News component
import CategoryStatsChart from '../components/articles/CategoryStatsChart';

const Index = () => {
  const { fetchArticles } = useArticleStore();
  const { fetchFeeds } = useFeedStore();

  useEffect(() => {
    fetchArticles();
    fetchFeeds();
  }, [fetchArticles, fetchFeeds]);

  // Main categories - keep Chinese IDs for database consistency
  const mainCategories = [
    { id: 'AI行业动态', title: 'AI Industry Highlights', color: "blue.500" },
    { id: 'Web3动态', title: 'Crypto Updates', color: "orange.500" },
    { id: '企业家动态', title: 'Entrepreneur News', color: "green.500" },
    { id: '投资人动态', title: 'Investor Updates', color: "purple.500" },
    { id: '一人公司动态', title: 'Solo Company News', color: "teal.500" }
  ];

  return (
    <Box mx="auto" maxWidth="1200px" px={{ base: 4, md: 6 }} py={{ base: 4, md: 6 }}>
      {/* 分类统计图表 */}
      <Box mb={12}>
        <CategoryStatsChart />
      </Box>
      
      {/* 网格布局 - 修改为适应5个分类 */}
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        gap={{ base: 6, md: 8 }}
        mb={12}
      >
        <GridItem><AIIndustryNews /></GridItem>
        <GridItem><Web3News /></GridItem>
        <GridItem><EntrepreneurNews /></GridItem>
        <GridItem><InvestorNews /></GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}><SoloCompanyNews /></GridItem>
      </Grid>
      
      {/* 热门文章排行榜 */}
      {/* HotArticlesTable component is not defined in the original file, so it's commented out */}
      {/* <HotArticlesTable mb={8} /> */}
    </Box>
  );
};

export default Index;
